import { ParentPage } from '@src/app/shared/typings/enum/pages.js'

/**
 * Checks if the url contains the given parent page as a part of the path.
 * Url defaults to location.href.
 */
export function hasParentPage(parentPage: ParentPage, url: string = location.href): boolean {
  return url.split('/').includes(parentPage)
}
